// import { useEffect, useState } from "react";

// export default function BagCutCalc() {
//   const [meter, setMeter] = useState("");
//   const [inch, setInch] = useState(0);
//   const [divideBy, setDivideBy] = useState("");
//   const [multiplyBy, setMultiplyBy] = useState("");
//   const [result, setResult] = useState(0);

//   // Convert Meter to Inch (no decimals)
//   useEffect(() => {
//     if (meter) {
//       setInch(Math.round(meter * 39.3701));
//     } else {
//       setInch(0);
//     }
//   }, [meter]);

//   // Final Calculation
//   useEffect(() => {
//     if (inch && divideBy && multiplyBy) {
//       const value = (inch / divideBy) * multiplyBy;
//       setResult(Math.round(value));
//     } else {
//       setResult(0);
//     }
//   }, [inch, divideBy, multiplyBy]);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
//       <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
//         <h2 className="text-xl font-bold mb-4 text-center">BagCutCalc</h2>

//         {/* Meter Input */}
//         <div className="mb-3">
//           <label className="block text-sm font-medium mb-1">
//             Length (Meter)
//           </label>
//           <input
//             type="number"
//             value={meter}
//             onChange={(e) => setMeter(e.target.value)}
//             className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
//             placeholder="Enter length in meter"
//           />
//         </div>

//         {/* Inch Auto */}
//         <div className="mb-3">
//           <label className="block text-sm font-medium mb-1">Inch (Auto)</label>
//           <input
//             type="text"
//             value={inch}
//             readOnly
//             className="w-full border rounded-lg px-3 py-2 bg-gray-100"
//           />
//         </div>

//         {/* Divide */}
//         <div className="mb-3">
//           <label className="block text-sm font-medium mb-1">Divide By</label>
//           <input
//             type="number"
//             value={divideBy}
//             onChange={(e) => setDivideBy(e.target.value)}
//             className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
//             placeholder="Enter divide value"
//           />
//         </div>

//         {/* Multiply */}
//         <div className="mb-4">
//           <label className="block text-sm font-medium mb-1">Multiply By</label>
//           <input
//             type="number"
//             value={multiplyBy}
//             onChange={(e) => setMultiplyBy(e.target.value)}
//             className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
//             placeholder="Enter multiply value"
//           />
//         </div>

//         {/* Result */}
//         <div className="text-center">
//           <p className="text-sm text-gray-500">Result</p>
//           <p className="text-2xl font-bold text-green-600">{result}</p>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";

export default function BagCutCalc() {
  const [meter, setMeter] = useState("");
  const [inch, setInch] = useState(0);
  const [divideBy, setDivideBy] = useState("");
  const [multiplyBy, setMultiplyBy] = useState("");
  const [result, setResult] = useState(0);

  const [totalAmount, setTotalAmount] = useState("");
  const [perPieceAmount, setPerPieceAmount] = useState(0);

  // Convert Meter to Inch
  useEffect(() => {
    if (meter) {
      setInch(Math.round(meter * 39.3701));
    } else {
      setInch(0);
    }
  }, [meter]);

  // Final Piece Calculation
  useEffect(() => {
    if (inch && divideBy && multiplyBy) {
      const value = (inch / divideBy) * multiplyBy;
      setResult(Math.round(value));
    } else {
      setResult(0);
    }
  }, [inch, divideBy, multiplyBy]);

  // Per Piece Amount Calculation
  useEffect(() => {
    if (result > 0 && totalAmount) {
      const value = totalAmount / result;
      setPerPieceAmount(value.toFixed(2));
    } else {
      setPerPieceAmount(0);
    }
  }, [result, totalAmount]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-center">BagCutCalc</h2>

        {/* Meter Input */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">
            Length (Meter)
          </label>
          <input
            type="number"
            value={meter}
            onChange={(e) => setMeter(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            placeholder="Enter length in meter"
          />
        </div>

        {/* Inch Auto */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Inch (Auto)</label>
          <input
            type="text"
            value={inch}
            readOnly
            className="w-full border rounded-lg px-3 py-2 bg-gray-100"
          />
        </div>

        {/* Divide */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Divide By</label>
          <input
            type="number"
            value={divideBy}
            onChange={(e) => setDivideBy(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            placeholder="Enter divide value"
          />
        </div>

        {/* Multiply */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Multiply By</label>
          <input
            type="number"
            value={multiplyBy}
            onChange={(e) => setMultiplyBy(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            placeholder="Enter multiply value"
          />
        </div>

        {/* Result */}
        <div className="text-center mb-4">
          <p className="text-sm text-gray-500">Total Pieces</p>
          <p className="text-2xl font-bold text-green-600">{result}</p>
        </div>

        {/* Total Amount Input */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">
            Total Amount
          </label>
          <input
            type="number"
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            placeholder="Enter total amount"
          />
        </div>

        {/* Per Piece Amount */}
        <div className="text-center">
          <p className="text-sm text-gray-500">Per Piece Amount</p>
          <p className="text-xl font-bold text-blue-600">
            ₹{perPieceAmount}
          </p>
        </div>

      </div>
    </div>
  );
}
